export default __webpack_public_path__ + "static/media/eat.f8aa8cfe.wav";